import { render, staticRenderFns } from "./VacancyListQrLinks.vue?vue&type=template&id=57bba2aa&scoped=true&"
import script from "./VacancyListQrLinks.vue?vue&type=script&lang=js&"
export * from "./VacancyListQrLinks.vue?vue&type=script&lang=js&"
import style0 from "./VacancyListQrLinks.vue?vue&type=style&index=0&id=57bba2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bba2aa",
  null
  
)

/* custom blocks */
import block0 from "./VacancyListQrLinks.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyListQrLinks.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
